import { handleActions } from 'redux-actions';
import {
    setVenues
} from '../actions/dashboardActions';

const defaultState = {
    venues: []
};

export default handleActions(
  {
    [setVenues](state, { payload }) {
      return { ...state, venues: payload };
    }
  },
  defaultState,
);
